import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { PageShell } from '../components/PageShell';
import { SectionHeading } from '../components/SectionHeading';
import { boardCompetencies, pillars, positioning } from '../data/profile';
export function ValueProposition() {
  return <PageShell path="/value-proposition" data-id="element-396" data-mp="1dg0rorf9uejw">
      <section className="bg-white py-20 lg:py-24" aria-labelledby="proposition-heading" data-id="element-397" data-mp="1diwq0gv1758v">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-398" data-mp="fvejlcouef81">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-399" data-mp="kt696020lp92">
            <div className="lg:col-span-5" data-id="element-400" data-mp="pr83xi8szd0d">
              <div id="proposition-heading" data-id="element-401" data-mp="pq6geealoy1r">
                <SectionHeading eyebrow="Value Proposition" title="What she brings to the table" data-id="element-402" data-mp="ur3wmlc1vi0m" />
              </div>
            </div>
            <div className="lg:col-span-7" data-id="element-403" data-mp="215v5pcbbu95q">
              <div className="border-t-2 border-gold-500 bg-platinum-100 p-8 lg:p-10" data-id="element-404" data-mp="265prx2k5qakg">
                <p className="font-display text-xl font-semibold leading-snug tracking-tight text-navy-900 lg:text-2xl" data-id="element-405" data-mp="267khwvaacsve">
                  {positioning}
                </p>
              </div>
            </div>
          </div>

          <div className="mt-20" data-id="element-406" data-mp="1c9bjft9bsqml">
            <h2 className="font-display text-2xl font-bold tracking-tight text-navy-900" data-id="element-407" data-mp="1c8i6gajrx4w0">
              Four pillars of executive value
            </h2>
            <div className="mt-8 grid grid-cols-1 gap-px border border-platinum-200 bg-platinum-200 md:grid-cols-2" data-id="element-408" data-mp="12bdjw9m0n7eo">
              {pillars.map((pillar, index) => <motion.article key={pillar.number} initial={{
              opacity: 0,
              y: 14
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.3
            }} transition={{
              duration: 0.28,
              delay: index % 2 * 0.05,
              ease: [0.23, 1, 0.32, 1]
            }} className="flex flex-col bg-white p-8 lg:p-10" data-id="element-409" data-mp="xjlzyhxd7zxi" data-mpi={index}>
                  <div className="flex items-baseline gap-4" data-id="element-410" data-mp="eof8hqcr6pnm">
                    <span className="font-display text-sm font-bold tracking-[0.12em] text-gold-600" data-id="element-411" data-mp="4wvtciw99j37">
                      {pillar.number}
                    </span>
                    <h3 className="font-display text-lg font-bold leading-snug tracking-tight text-navy-900" data-id="element-412" data-mp="3r66wwsihepf1">
                      {pillar.title}
                    </h3>
                  </div>
                  <p className="mt-4 font-sans text-sm leading-relaxed text-charcoal-600" data-id="element-413" data-mp="noewqqu6yz5r">
                    {pillar.description}
                  </p>
                  <ul className="mt-auto space-y-2.5 pt-7" data-id="element-414" data-mp="sq4867lbteud">
                    {pillar.points.map(point => <li key={point} className="flex items-start gap-2.5" data-id="element-415" data-mp="dxaqcfil0mmj">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-600" aria-hidden="true" data-id="element-416" data-mp="iwf29dww4ygk" />
                        <span className="font-sans text-sm font-medium text-navy-900" data-id="element-417" data-mp="16lpto4scpgi1">{point}</span>
                      </li>)}
                  </ul>
                </motion.article>)}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-navy-900 py-20 lg:py-24" aria-labelledby="competencies-heading" data-id="element-418" data-mp="2r5brwtcqs0q5">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-419" data-mp="35tg2tb5jz7yd">
          <div id="competencies-heading" data-id="element-420" data-mp="30v4rsx3iurek">
            <SectionHeading eyebrow="Board Competencies" title="Competency map for a board skills matrix" description="How her capability maps to the competencies boards are required to hold collectively." tone="dark" data-id="element-421" data-mp="30w6bfpylsm7w" />
          </div>

          <ul className="mt-12 grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-422" data-mp="2m8370l07lil7">
            {boardCompetencies.map(competency => <li key={competency.name} className="flex flex-col bg-navy-900 p-8" data-id="element-423" data-mp="1fzx3z4tskky">
                <h3 className="font-display text-base font-bold leading-snug text-white" data-id="element-424" data-mp="3tklq2bdtp2ip">
                  {competency.name}
                </h3>
                <p className="mt-auto pt-4 font-sans text-sm leading-relaxed text-platinum-300" data-id="element-425" data-mp="sqp1kngysd74">
                  {competency.detail}
                </p>
              </li>)}
          </ul>
        </div>
      </section>
    </PageShell>;
}